import PropTypes from 'prop-types';

export const documentProptype = PropTypes.shape({
  country: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  is_back_required: PropTypes.bool.isRequired,
  is_address_extractable: PropTypes.bool.isRequired
});

export const imageProptype = PropTypes.shape({
  image: PropTypes.string.isRequired,
  invertX: PropTypes.bool.isRequired
});

export const analyticProptype = PropTypes.shape({
  ga: PropTypes.shape({
    category: PropTypes.string,
    action: PropTypes.string,
    label: PropTypes.string
  })
});

export const paymentBreakdownProptype = PropTypes.shape({
  selectedOriginalCurrency: PropTypes.bool,
  fixedSideBuy: PropTypes.bool,
  fixedSideSell: PropTypes.bool,
  transactionFeeAmount: PropTypes.number,
  fxFeeAmount: PropTypes.number,
  transactionIncludesFx: PropTypes.bool,
  hasFees: PropTypes.bool,
  subtotalShown: PropTypes.bool,
  totalAmount: PropTypes.number,
  totalCurrency: PropTypes.string,
  showOrderTotalSummary: PropTypes.bool,
  originalAmountShown: PropTypes.bool,
  cartHasItems: PropTypes.bool,
  hideCartItems: PropTypes.bool,
  enableExpand: PropTypes.bool,
  showCartItems: PropTypes.bool,
  cartTotalItemsLength: PropTypes.number
});
